import { render } from "./EntryDetails.vue?vue&type=template&id=7da1effb"
import script from "./EntryDetails.vue?vue&type=script&lang=ts"
export * from "./EntryDetails.vue?vue&type=script&lang=ts"

import "./EntryDetails.vue?vue&type=style&index=0&id=7da1effb&lang=scss"
script.render = render

export default script